// Copyright (c) 2022 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";

import { RoutedProps, withRouter } from "view/reactrouterinterceptor";
import ChargingSessionList from "./ChargingSessionList";

import SiteBar, { ISiteBarSearchFieldProps } from "view/comp/SiteBar";
import { defineMessages } from "react-intl";
import { IOcppCharger } from "states/ocppstates";
import { IState } from "states/states";

interface IChargingSessionPageProps {
  ocppChargers: IOcppCharger[];
}

const mapStateToProps = (state: IState) => {
  const props: IChargingSessionPageProps = {
    ocppChargers: state.ocpp.charger,
  };

  return props;
};

const messages = defineMessages({
  placeholderSearchField: {
    id: "Search for charging sessions...",
  },
  toolTipSearchField: {
    id: "Search for charger name, vendor, serial number, user name, card number or category. To search for multiple fields, separate search texts by a space!",
  },
});

class ChargingSessionPageComponent extends React.Component<
  RoutedProps & IChargingSessionPageProps
> {
  public render() {
    const searchFieldProps: ISiteBarSearchFieldProps = {
      placeholder: messages.placeholderSearchField,
      toolTip: messages.toolTipSearchField,
      dataListId: "chargerOptions",
    };
    return (
      <div className="flex-self flex-content">
        <SiteBar showPeriodSelect={true} searchFieldProps={searchFieldProps} />
        {this.renderChargerOptions("chargerOptions")}

        <ChargingSessionList />
      </div>
    );
  }

  private renderChargerOptions(inId: string) {
    const chargerItems = this.props.ocppChargers.map((curCharger) => {
      return <option key={curCharger.fk_charger} value={curCharger.chargepoint} />;
    });

    return <datalist id={inId}>{chargerItems}</datalist>;
  }
}

export default connect(mapStateToProps)(withRouter(ChargingSessionPageComponent));
